import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="trigger-event"
export default class extends Controller {
  trigger(event) {
    this.dispatch(event.params.event)
  }
}
